import {Directive, forwardRef} from "@angular/core";
import {FormLayout} from "./form-layout";
import {CapFormColumnsDirective} from "./form-columns.directive";

@Directive({
  selector: 'form-row',
  host: {
    'class': 'form-row bsg-form-group'
  },
  providers: [
    {provide: FormLayout, useExisting: forwardRef(() => CapFormRowDirective)}
  ]
})
export class CapFormRowDirective extends CapFormColumnsDirective {

  constructor() {
    super();
  }

  groupClasses = "";
}
